import { authAPI } from "../auth/auth";

export const shipmentsAPI = {
    async upload() {
        let resp = await fetch("/api/shipments").catch((error) =>
            console.log(error)
        );

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.upload();
            }

            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body || !body.ok) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        return {
            ok: true,
            shipments: body.shipments,
        };
    },
    async uploadShipmentDeliveryPrices(shipmentID) {
        let resp = await fetch(
            `/api/shipments/${shipmentID}/delivery-price`
        ).catch((error) => console.log(error));
        
        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.uploadShipmentDeliveryPrices(shipmentID);
            }
            
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body || !body.ok) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        return {
            ok: true,
            prices: body.prices,
        };
    },
    async uploadShipmentTotalPrices(shipmentID) {
        let resp = await fetch(
            `/api/shipments/${shipmentID}/total-prices`
        ).catch((error) => console.log(error));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.uploadShipmentTotalPrices(shipmentID);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp.json().catch(e => error = e)
        if(!body || error) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(body.ok) {
            return {
                ok: true,
                prices: body.prices
            }
        }

        if(body.err) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }
    },
    async uploadOneShipment(shipmentID) {
        let resp = await fetch(`/api/shipments/${shipmentID}`).catch((e) =>
            console.log(e)
        );

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.uploadOneShipment(shipmentID);
            }
            return {
                unauthorized: true,
            };
        }

        if (body.ok) {
            return {
                ok: true,
                shipment: body.shipment,
            };
        }

        if (body.err) {
            return {
                ok: false,
                err: body.err,
            };
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },
    async uploadShipmentBoxes(shipmentID) {
        let resp = await fetch(`/api/shipments/${shipmentID}/boxes`).catch(
            (error) => console.log(error)
        );

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.uploadShipmentBoxes();
            }

            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body || !body.ok) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        return {
            ok: true,
            shipmentBoxes: body.boxes,
        };
    },
    async create(data) {
        let dataJSON = JSON.stringify(data);
        let resp = await fetch("/api/shipments", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: dataJSON,
        }).catch((error) => {
            console.log(error);
        });

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.create(data);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }
        
        if (body.ok) {
            return {
                ok: true,
                shipment: body.shipment,
            };
        }

        if (body.validationErrors) {
            return {
                ok: false,
                validationErrors: body.validationErrors,
            };
        }

        switch(body.err){
            case "receiver city not found":  {
                return {
                    ok: false,
                    err: "city_not_found",
                };
            }
            default: {
                return {
                    ok: false,
                    err: "something_went_wrong",
                };
            }
        }

    },
    async createShipmentItem(shipmentID, data) {
        if (!shipmentID || !data) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let jsonBody = JSON.stringify(data);

        let resp = await fetch(`/api/shipments/${shipmentID}/items`, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: jsonBody,
        }).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.createShipmentItem(shipmentID, data);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if(body.ok) {
            return {
                ok: true,
                shipmentItem: body.shipmentItem,
            };
        }

        if(body.validationErrors) {
            return {
                ok: false,
                validationErrors: body.validationErrors,
            };
        }

        if(body.err === "shipment is blocked") {
            return {  
                ok: false,
                err: "shipment_is_blocked",
            }
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };

    },
    async createShipmentBox(shipmentID, sizes) {
        if (!shipmentID) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }
        if (!sizes) {
            return {
                ok: false,
                err: "shipment_box_sizes_not_found",
            };
        }

        let preparedData = {
            length: +sizes.length,
            width: +sizes.width,
            height: +sizes.height,
            weight: +sizes.weight,
        };

        let resp = await fetch(`/api/shipments/${shipmentID}/boxes`, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: JSON.stringify(preparedData),
        }).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.createShipmentBox(shipmentID, sizes);
            }

            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if(body.ok) {
            return {
                ok: true,
                box: body.box,
            };
        }

        if(body.err === "shipment is blocked") {
            return {  
                ok: false,
                err: "shipment_is_blocked",
            }
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };

    },
    async updateShipment(data, shipmentID) {
        let dataJSON = JSON.stringify(data);
        let resp = await fetch(`/api/shipments/${shipmentID}`, {
            method: "PUT",
            headers: {
                "Content-type": "application/json",
            },
            body: dataJSON,
        }).catch((error) => {
            console.log(error);
        });

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();

            if (refreshed) {
                return await this.updateShipment(data, shipmentID);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }
        if (body.ok) {
            return {
                ok: true,
                shipment: body.shipment,
            };
        }
    
        if (body.validationErrors) {
            return {
                ok: false,
                validationErrors: body.validationErrors,
            };
        }
        switch(body.err) {
            case "receiver city not found": {
                return {
                    ok: false,
                    err: "city_not_found",
                };
            }
            case "shipment is blocked": {
                return {
                    ok: false,
                    err: "shipment_is_blocked",
                };
            }
            default: {
                return {
                    ok: false,
                    err: "something_went_wrong",
                };
            }
        }    

    },
    async updateShipmentItem(shipmentID, shipmentItemID, data) {
        if (!shipmentID || !shipmentItemID || !data) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let jsonBody = JSON.stringify(data);

        let resp = await fetch(
            `/api/shipments/${shipmentID}/items/${shipmentItemID}`,
            {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                },
                body: jsonBody,
            }
        ).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.updateShipmentItems(
                    shipmentID,
                    shipmentItemID,
                    data
                );
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }
        if (body.ok) {
            return {
                ok: true,
                shipmentItem: body.shipmentItem,
            };
        }

        if (body.validationErrors) {
            return {
                ok: false,
                validationErrors: body.validationErrors,
            };
        }

        if (body.err === "shipment is blocked") {
            return {
                ok: false,
                err: "shipment_is_blocked",
            };
        }

        if (body.err) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },
    async updateShipmentBox(shipmentID, boxID, sizes) {
        if (!shipmentID || !boxID || !sizes) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let preparedData = {
            length: +sizes.length,
            width: +sizes.width,
            height: +sizes.height,
            weight: +sizes.weight,
        };

        let jsonBody = JSON.stringify(preparedData);

        let resp = await fetch(
            `/api/shipments/${shipmentID}/boxes/${boxID}`,
            {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                },
                body: jsonBody,
            }
        ).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.updateShipmentBox(
                    shipmentID,
                    boxID,
                    sizes
                );
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }
        if (body.ok) {
            return {
                ok: true,
                box: body.box,
            };    
        }

        if (body.validationErrors) {
            return {
                ok: false,
                validationErrors: body.validationErrors,
            };
        }

        if (body.err === "shipment is blocked") {
            return {
                ok: false,
                err: "shipment_is_blocked",
            };
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };

    },
    async deleteShipment(shipmentID) {
        if (!shipmentID) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let resp = await fetch(`/api/shipments/${shipmentID}`, {
            method: "DELETE",
        });

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.deleteShipment(shipmentID);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
            };
        }

        if (body.err === "shipment is blocked") {
            return {
                ok: false,
                err: "shipment_is_blocked",
            };
        }

        if (body.err) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },
    async deleteShipmentItem(shipmentID, shipmentItemID) {
        if (!shipmentID || !shipmentItemID) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let resp = await fetch(`/api/shipments/${shipmentID}/items/${shipmentItemID}`, {
            method: "DELETE",
        });

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.deleteShipmentItem(shipmentID, shipmentItemID);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
            };
        }

        switch (body.err) {
            case "shipment is blocked":
                return {
                    ok: false,
                    err: "shipment_is_blocked",
                };
            case "shipment not found":
                return {
                    ok: true
                }
            default:
                return {
                    ok: false,
                    err: "something_went_wrong",
                };
            }
    },
    async deleteShipmentBox(shipmentID, boxID) {
        if (!shipmentID || !boxID) {
            return {
                ok: false,
                err: "undefined shipmentID or boxID",
            };
        }

        let resp = await fetch(`/api/shipments/${shipmentID}/boxes/${boxID}`, {
            method: "DELETE",
        });

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.deleteShipmentBox(shipmentID, boxID);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
            };
        }
        
        if (!body.err) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.err === "shipment is blocked") {
            return {
                ok: false,
                err: "shipment_is_blocked",
            };
        }

        if (body.err === "shipment box not found") {
            return { ok: true };
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },
    async sendShipmnentToAkad(shipmentID) {
        if (!shipmentID) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }
        let resp = await fetch(`/api/shipments/${shipmentID}/send-to-akad`, {
            method: "POST",
        }).catch(e => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.sendShipmnentToAkad(shipmentID);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");
        
        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
                shipment: body.shipment,
            };
        }

        switch(body.err) {
            case "shipment is blocked":
                return {
                    ok: false,
                    err: "shipment_is_blocked",
                };
            case "shipment not found":
                return {
                    ok: false,
                    err: "shipment_not_found",
                }
            case "shipment has no boxes":
                return {
                    ok: false,
                    err: "errors.sending_shipment.shipment_has_no_boxes",
                }
            case "box has no items":
                return {
                    ok: false,
                    err: "errors.sending_shipment.box_has_no_items",
                }
            case "invalid sizes of box":
                return {
                    ok: false,
                    err: "errors.sending_shipment.invalid_sizes_of_box",
                }
            case "shipment has no ETGB file":
                return {
                    ok: false,
                    err: "errors.sending_shipment.shipment_has_no_ETGB_file",
                }
            case "shipment has no own invoice file":
                return {
                    ok: false,
                    err: "errors.sending_shipment.shipment_has_no_own_invoice_file",
                }
            case "unable to reserve hepsijet delivery":
                return {
                    ok: false,
                    err: "errors.sending_shipment.hepsi_jet_unknown_error",
                }
            case "hepsijet requires sender district":
                return {
                    ok: false,
                    err: "errors.sending_shipment.hepsi_jet_requires_sender_district",
                }
            default:
                return {
                    ok: false,
                    err: "something_went_wrong",
                };
        }
    },
    async uploadEvents(shipmentTrc) {
        if(!shipmentTrc) {
            return {
                ok: false,
                err: "not_sended_shipment_does_not_have_events"
            }
        }

        let resp = await fetch(`/api/events/shipments/${shipmentTrc}`).catch(e => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.uploadEvents(shipmentTrc);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
                shipment: body.shipment,
            };
        }

        if (body.err === "shipment not found") {
            return {
                ok: false,
                err: "shipment_not_found",
            };
        }

        if (body.err === "cannot get events of unblocked shipment") {
            return {
                ok: false,
                err: "not_sended_shipment_does_not_have_events",
            }
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },
    async uploadShipmentBills() {
        const resp = await fetch(`/api/shipment-bills`).catch(
            (error) => console.log(error)
        );

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.uploadShipmentBills();
            }

            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp.json().catch(e => error = e)
        if(!body || error)
        {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(body.ok) {
            return {
                ok: true,
                shipmentBills: body["bills"]
            }
        }

        if(body.err) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }
    },
    async updateShipmentDocsWeight(shipmentID, weight) {
        console.log("shipmentID: ", shipmentID, "weight: ", weight)
        if (!shipmentID || !weight) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let jsonBody = JSON.stringify({
            weight
        });

        let resp = await fetch(
            `/api/shipments/${shipmentID}/docs-weight`,
            {
                method: "PATCH",
                headers: {
                    "Content-type": "application/json",
                },
                body: jsonBody,
            }
        ).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.updateShipmentDocsWeight(
                    shipmentID,
                    weight
                );
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }
        if (body.ok) {
            return {
                ok: true,
            };    
        }

        if (body.validationErrors) {
            return {
                ok: false,
            };
        }

        if (body.err === "shipment is blocked") {
            return {
                ok: false,
                err: "shipment_is_blocked",
            };
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };

    },
    async sendEtgbBillDocument(shipmentID, file) {
        if (!shipmentID || !file) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let formData = new FormData();
        formData.append("document", file);

        let resp = await fetch(
            `/api/shipments/${shipmentID}/etgb-bill`,
            {
                method: "POST",
                body: formData,
            }
        ).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.sendEtgbBillDocument(
                    shipmentID,
                    file
                );
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp.json().catch(e => error = e)
        if(!body || error)
        {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(body.ok) {
            return {
                ok: true,
                fileName: body.fileName
            }
        }

        if(body.err) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }
    },
    async sendOwnInvoice(shipmentID, file) {
        if (!shipmentID || !file) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let formData = new FormData();
        formData.append("document", file);

        let resp = await fetch(
            `/api/shipments/${shipmentID}/own-invoice`,
            {
                method: "POST",
                body: formData,
            }
        ).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.sendEtgbBillDocument(
                    shipmentID,
                    file
                );
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp.json().catch(e => error = e)
        if(!body || error)
        {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(body.ok) {
            return {
                ok: true,
                fileName: body.fileName
            }
        }

        if(body.err) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }
    },
    async sendC2CFile(shipmentID, file) {
        if (!shipmentID || !file) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        let formData = new FormData();
        formData.append("document", file);

        let resp = await fetch(
            `/api/shipments/${shipmentID}/c2c-file`,
            {
                method: "POST",
                body: formData,
            }
        ).catch((e) => console.log(e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.sendC2CFile(
                    shipmentID,
                    file
                );
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp.json().catch(e => error = e)
        if(!body || error)
        {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(body.ok) {
            return {
                ok: true,
                fileName: body.fileName
            }
        }

        if(body.err) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }
    },
    async setInvoiceType(shipmentID, invoiceType) {
        if(!shipmentID || !invoiceType) {
            return {
                ok: false,
                err: "invalid_data"
            }
        }

        let resp = await fetch(`/api/shipments/${shipmentID}/invoice-type`, {
            method: "PATCH",
            headers: {
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                "invoice-type": invoiceType
            })
        }).catch(e => console.log(e))

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.setInvoiceType(
                    shipmentID,
                    invoiceType
                );
            }
            return {
                unauthorized: true,
            };
        }

        let error = null
        let body = await resp.json().catch(e => error = e)
        if(!body || error)
        {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(body.ok) {
            return {
                ok: true,
            }
        }

        if(body.err) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }
    },
};